export default class H5ConfigModel {
  constructor (oriData = {}, productId = '') {
    this.id = oriData.id || ''
    this.configId = oriData.configId || ''
    this.productId = oriData.productId || productId
    this.title = oriData.title || ''
    this.welcomes = oriData.welcomes || ''
    this.ttsConfiguration = parseInt(oriData.ttsConfiguration) || 0
    this.topBannerFlag = !!oriData.topBannerFlag
    this.topBannerImage = oriData.topBannerImage || ''
    this.topBannerLink = oriData.topBannerLink || ''
    this.adFlag = !!oriData.adFlag
    this.adDialogue = parseInt(oriData.adDialogue) || -1
    this.adImage = oriData.adImage || ''
    this.adLink = oriData.adLink || ''
    this.bottomDiversionFlag = !!oriData.bottomDiversionFlag
    this.bottomShareFlag = !!oriData.bottomShareFlag
    this.image = oriData.image || ''
    this.volume = oriData.volume || ''
    this.speed = oriData.speed || ''
    this.voiceId = oriData.voiceId || ''
  }
}



// WEBPACK FOOTER //
// ./src/app/GenH5/H5ConfigModel.js